import { z } from 'zod';
import { MAXIMUM_FREE_DAYS } from './subscriptionConfiguration.js';
// Separate from the configure and info shapes: a validation may move this one number and nothing else.
export const subscriptionFreeDaysSchema = z.object({
    initialFreeDays: z.coerce.number().int().min(0).max(MAXIMUM_FREE_DAYS),
});
